import type { GeneralResp } from '@/models/GeneralResp';
import type { AxiosResponse } from 'axios';
import * as ApiClient from '@/libs/ApiClient';
import { RouteUrlList } from '@/libs/RouteList';

export enum AccountType {
    deposite = 'deposite', // 台幣出金 / 外幣出金
    withdrawal = 'withdrawal' // 台幣外幣入金
}
/**
 * @todo 台幣/外幣帳戶空物件樣板
 */
declare interface IAccount {
    coin: {
        twd: boolean;
        usd: boolean;
        cny: boolean;
        jpy: boolean;
    };
    bank: string;
    branch: string;
    number: string;
    fileNo: string | null | undefined;
    base64Src: string | null | undefined;
    type: AccountType;
    index: number;
}

declare interface ProofDocObj {
    index: number;
    fileNo: string | null | undefined; // 上傳後的id
}

/**
 * @todo Api 傳入值
 */
export interface ProofDocUploadPostBackReq {
    ntdAccount: IAccount;
    foreignAccount: IAccount;
    passportOrCreditCard: string;
    withdrawalForeignAccounts: IAccount[];
    financeProof: ProofDocObj[];
    financialProofAgree: string;
}
/**
 * @todo Api 回傳值
 */
export interface ProofDocUploadPostBackResp extends GeneralResp {}

/**
 * @todo 出入金帳號約定/證明文件上傳 ViewData
 */
const ProofDocUploadPostBack = (data: ProofDocUploadPostBackReq): Promise<ProofDocUploadPostBackResp> => {
    const url = RouteUrlList.API_ProofDocUploadPostBack.path;
    const config = {
        params: { showOverlay: ApiClient.paramTypeEnum.true, getServiceAlert: ApiClient.paramTypeEnum.true }
    };
    return ApiClient.post(url, data, config).then((res: AxiosResponse<ProofDocUploadPostBackResp>) => {
        return res.data;
    });
};

export default ProofDocUploadPostBack;
